import PropTypes from 'prop-types';
import localizer from '../localizer';
import { views as Views } from './constants';

export const elementType = PropTypes.elementType;

export const eventComponent = PropTypes.oneOfType([
  elementType,
  PropTypes.shape({
    month: elementType,
    week: elementType,
    day: elementType,
    agenda: elementType,
  }),
]);

const viewNames = Object.keys(Views).map(k => Views[k]);

export const accessor = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.func,
]);

// Create a simple chainable type checker replacement
const createChainableTypeChecker = (validate) => {
  const checkType = (isRequired, props, propName, componentName, location, propFullName, ...rest) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error(
          `The ${location} \`${propFullNameSafe}\` is marked as required in \`${componentNameSafe}\`, but its value is \`${props[propName]}\`.`
        );
      }
      return null;
    }
    
    return validate(props, propName, componentName, location, propFullNameSafe, ...rest);
  };

  const chainedChecker = checkType.bind(null, false);
  chainedChecker.isRequired = checkType.bind(null, true);

  return chainedChecker;
};

export const dateFormat = createChainableTypeChecker(
  (...args) => localizer.propType && localizer.propType(...args)
);

// Custom validation function for the all prop type equivalent
const allValidators = (validators) => {
  return (props, propName, componentName, ...rest) => {
    for (let i = 0; i < validators.length; i++) {
      const result = validators[i](props, propName, componentName, ...rest);
      if (result) {
        return result;
      }
    }
    return null;
  };
};

export const views = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.oneOf(viewNames)),
  allValidators([
    PropTypes.object,
    (props, propName, componentName) => {
      const prop = props[propName];
      if (!prop || typeof prop !== 'object') {
        return new Error(
          `Invalid ${propName} supplied to ${componentName}. Expected an object.`
        );
      }

      let error = null;
      Object.keys(prop).every((key) => {
        const isBuiltinView = viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
        
        if (!isBuiltinView) {
          const elementTypeError = elementType(prop, key, componentName);
          if (elementTypeError) {
            error = elementTypeError;
            return false; // break the loop
          }
        }
        return true; // continue the loop
      });

      return error;
    },
  ]),
]);